import bugsnag from '@bugsnag/js';

import {
  BUGSNAG_ERROR_CLASSES,
  BUGSNAG_GRAPHQL_IGNORED_OPERATIONS,
  BUGSNAG_NETWORK_IGNORED_OPERATIONS,
} from 'utils/constants';

export const notifyError = ({
  errorClass = BUGSNAG_ERROR_CLASSES.DEFAULT_ERROR,
  message,
  severity,
  metadata = {},
}) => {
  const error = {
    name: errorClass,
    message,
  };

  bugsnag.notify(error, (event) => {
    event.severity = severity;
    event.groupingHash = errorClass;
    for (const metaKey of Object.keys(metadata)) {
      event.addMetadata(metaKey, metadata[metaKey]);
    }
  });
};

export const notifyOrderManagerLoaded = () => {
  notifyError({
    errorClass: BUGSNAG_ERROR_CLASSES.DEFAULT_INFO,
    message: `Order Manager Loaded`,
    severity: 'info',
  });
};

export const notifySpinnerTimeout = (timeout) => {
  notifyError({
    errorClass: BUGSNAG_ERROR_CLASSES.SPINNER_TIMEOUT,
    message: `${timeout}s limit was reached`,
    severity: 'warning',
  });
};

export const notifyGraphqlError = (graphqlError) => {
  const { graphQLErrors, networkError, operation, response } = graphqlError;

  if (operation.query) {
    operation.query = operation.query.loc.source.body;
  }

  const customMessage = operation.operationName + ' Error';

  if (!BUGSNAG_GRAPHQL_IGNORED_OPERATIONS.includes(operation.operationName) && graphQLErrors) {
    notifyError({
      errorClass: BUGSNAG_ERROR_CLASSES.GRAPHQL_ERROR,
      message: customMessage,
      severity: 'warning',
      metadata: {
        GraphQL_Response: response,
        GraphQL_Request: operation,
      },
    });
  }

  if (!BUGSNAG_NETWORK_IGNORED_OPERATIONS.includes(operation.operationName) && networkError) {
    notifyError({
      errorClass: BUGSNAG_ERROR_CLASSES.GRAPHQL_NETWORK_ERROR,
      message: customMessage,
      severity: 'warning',
      metadata: {
        GraphQL_Network_Error: networkError,
        GraphQL_Request: operation,
      },
    });
  }
};

export const notifyAccountSwitch = ({
  initialAccountId,
  finalAccountId,
  shoppingCart,
  hasQuoteUnsavedChanges,
  currentRma,
}) => {
  const hasRmaItems = currentRma && currentRma.items.length;

  const message =
    hasRmaItems || hasQuoteUnsavedChanges
      ? 'User switched accounts. Incomplete data on storage got erased.'
      : 'User switched accounts. No data was lost.';

  notifyError({
    errorClass: BUGSNAG_ERROR_CLASSES.DEFAULT_INFO,
    severity: 'info',
    message,
    metadata: {
      switched_accounts: {
        initialAccount: initialAccountId,
        finalAccount: finalAccountId,
      },
      erased_data: {
        currentRma: hasRmaItems ? currentRma : null,
        shoppingCart: hasQuoteUnsavedChanges ? shoppingCart : null,
      },
    },
  });
};

export const notifyCommerceIncomplete = () => {
  notifyError({
    errorClass: BUGSNAG_ERROR_CLASSES.USER_ERROR,
    message: `Commerce incomplete account`,
    severity: 'warning',
  });
};
